import {
  API_STATES
} from '@/helpers'

const state = {
  mySchedulesState           : API_STATES.NOT_REQUESTED,
  mySchedulesError           : null,
  mySchedules                : {},
  userAttendanceSummaryState : API_STATES.NOT_REQUESTED,
  userAttendanceSummaryError : null,
  userAttendanceSummary      : {},

  currentWeekTimeOffsState : API_STATES.NOT_REQUESTED,
  currentWeekTimeOffsError : null,
  currentWeekTimeOffs      : [],
  nextWeekTimeOffsState    : API_STATES.NOT_REQUESTED,
  nextWeekTimeOffsError    : null,
  nextWeekTimeOffs         : [],

  dropScheduleState : API_STATES.NOT_REQUESTED,
  dropScheduleError : null,

  availableShiftsGetState        : API_STATES.NOT_REQUESTED,
  availableShiftsGetError        : null,
  availableShifts                : [],
  availableShiftsUpdateState     : API_STATES.NOT_REQUESTED,
  availableShiftsUpdateError     : null,
  applyOpenShiftState            : API_STATES.NOT_REQUESTED,
  applyOpenShiftError            : null,
  cancelOpenShiftState           : API_STATES.NOT_REQUESTED,
  cancelOpenShiftError           : null,
  applySuccessMessage            : '',
  cancelSuccessMessage           : '',
  dashboardThisWeekStats         : {},
  dashboardThisWeekStatsGetState : API_STATES.NOT_REQUESTED,
  dashboardStatsGetError         : null,
  actualSalesByInterval          : {},
  actualSalesGetState            : API_STATES.NOT_REQUESTED,
  actualSalesGetError            : null,
  dashboardMetricsStats          : {},
  dashboardMetricsStatsGetState  : API_STATES.NOT_REQUESTED,
  dashboardMetricsStatsGetError  : null,
  dashboardLastWeekStats         : {},
  dashboardLastWeekStatsGetState : API_STATES.NOT_REQUESTED,
  dashboardLastWeekStatsGetError : null,
  dashboardHotFloorStats         : {},
  dashboardHotFloorStatsGetState : API_STATES.NOT_REQUESTED,
  dashboardHotFloorStatsGetError : null,

  requests           : [],
  requestsGetState   : API_STATES.NOT_REQUESTED,
  requestsGetError   : null,
  requestDeleteState : API_STATES.NOT_REQUESTED,
  requestDeleteError : null,
  requestUpdateState : API_STATES.NOT_REQUESTED,
  requestUpdateError : null,

  shiftRequests         : [],
  shiftRequestsGetState : API_STATES.NOT_REQUESTED,
  shiftRequestsGetError : null,

  messages         : [],
  messagesGetState : API_STATES.NOT_REQUESTED,
  messagesGetError : null,

  notificationMessages         : [],
  notificationMessagesGetState : API_STATES.NOT_REQUESTED,
  notificationMessagesGetError : null,

  refreshMessages : false,

  getSwappableEmployeesState : API_STATES.NOT_REQUESTED,
  getSwappableEmployeesError : null,
  swappableEmployeesData     : [],

  requestTypes         : [],
  requestTypesGetState : API_STATES.NOT_REQUESTED,
  requestTypesGetError : null,

  deleteRequestsState : API_STATES.NOT_REQUESTED,
  deleteRequestsError : null,


  messageReadState : API_STATES.NOT_REQUESTED,
  messageReadError : null,

  messageUpdateState : API_STATES.NOT_REQUESTED,
  messageUpdateError : null,

  userRequestsGetState : API_STATES.NOT_REQUESTED,
  userRequestsGetError : null,
  userRequests         : [],

  getLaborBudgetState : API_STATES.NOT_REQUESTED,
  getLaborBudgetError : null,
  laborBudgetStats    : {
    punched    : { grandTotalCost : 0, grandTotalHours : 0 },
    scheduled  : { grandTotalCost : 0, grandTotalHours : 0 },
    statistics : { budgetValueForInterval : 0 }
  },

  storeInsightsState : API_STATES.NOT_REQUESTED,
  storeInsightsError : null,
  storeInsights      : {},

  todaySchedulesState : API_STATES.NOT_REQUESTED,
  todaySchedulesError : null,
  todaySchedules      : {},

  completedTasksState      : API_STATES.NOT_REQUESTED,
  completedTasksStateError : null,
  completedTasks           : {},

  allUncompletedTasksState      : API_STATES.NOT_REQUESTED,
  allUncompletedTasksStateError : null,
  allUncompletedTasks           : {},

  allUnassignedTasksState      : API_STATES.NOT_REQUESTED,
  allUnassignedTasksStateError : null,
  allUnassignedTasks           : {},

  MyTasksState      : API_STATES.NOT_REQUESTED,
  MyTasksStateError : null,
  MyTasks           : {},
  
  assignedStoreTasksState      : API_STATES.NOT_REQUESTED,
  assignedStoreTasksStateError : null,
  assignedStoreTasks           : [],

  UpdateMyTasksState  : API_STATES.NOT_REQUESTED,
  UpdateMyStateError  : null,
  UpdateMyTasks       : {},
  UpdateTaskRequest   : [],
  weatherDetailsState : API_STATES.NOT_REQUESTED,
  weatherDetailsError : null,
  weatherDetails      : {
    foreCaseData : {},
    todayData    : {}
  },

  employeeScheduleRequest : API_STATES.NOT_REQUESTED,
  employeeSchedule        : [],
  employeeScheduleError   : null,
  employeeWSRequestState  : API_STATES.NOT_REQUESTED,
  employeeWSRequest       : {},
  employeeWSRequestError  : null
}

export default state
